$(document).ready(function(){
  $("#share-email-popup").hide();

  var clipboard = new Clipboard('#swell-copy-clipboard-btn');

  //referral section start ....
  $(document).on("swell:setup", function(){
    
        var customerDetails = swellAPI.getCustomerDetails();
    
    if(spapi && spapi.storage && spapi.storage.getItem("referrer_email")) {
      $("#enter-email-popup").hide();
      $("#share-email-popup").show();
    } else if (customerDetails.email) {
      $("#share-email-popup").show();
    } else {
      $("#enter-email-popup").show();
      $("#share-email-popup").hide();
    }
    
    $("#swell-submit-register-email").click(function(){

      var old_html = $("#swell-submit-register-email").html();
      $("#swell-submit-register-email").html("Registering...");

      var entered_email = $("#customer_entered_email").val();
      swellAPI.identifyReferrer(entered_email, function(details){
        $("#swell-submit-register-email").html(old_html);
        $("#enter-email-popup").hide();
        $("#share-email-popup").show();

      }, function(err){
        $("#swell-submit-register-email").html(old_html);
        $("#customer_entered_email").addClass("invalid-email");
      });
    });

    var referredCustomersInput = $("#referred-customers-input");

    $("#referred-customers-send-btn").off().on('click', function(e) {

      var old_html = $("#referred-customers-send-btn").html();
      $("#referred-customers-send-btn").html("Sending...");
      // assuming you allowed comma separated email input
      var emails = referredCustomersInput.val().split(",");

      var onSuccess = function(){
        $("#referred-customers-send-btn").html(old_html);
        $("#thankYouModal").modal("show");
        $("#referred-customers-input").removeClass("invalid-email");
        $("#referred-customers-input").val('');
      }

      var onError = function(err){
        $("#referred-customers-send-btn").html(old_html);
        $("#referred-customers-input").addClass("invalid-email");
      }

      swellAPI.sendReferralEmails(emails,onSuccess, onError);

    });	

  });
});
